import { html, LitElement } from 'lit-element';
import { aggregateStyles } from '../cssUtils.js';

/**
 * @element math-inline-aggregate
 * @prop {Object} model - The model for the pie
 * @prop {Object} aggregate - The aggregate
 */
export class MathInlineAggregate extends LitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      aggregate: { type: Array, attribute: false },
    };
  }

  _renderResponses() {
    const { responses, incorrect, averageScore, partiallyCorrect, correct } =
      this.aggregate || {};

    return html`
      <span>Responses: ${responses}</span><br />
      <span>Average Score: ${averageScore ? averageScore.toFixed(2) : 0}</span
      ><br />
      <span>Correct: ${correct}</span><br />
      <span>Partially Correct: ${partiallyCorrect}</span><br />
      <span>Incorrect: ${incorrect}</span><br />
      <br />
    `;
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <style>
        ${aggregateStyles}
      </style>
      <div class="aggregate">${this._renderResponses()}</div>`;
  }
}

export default MathInlineAggregate;
